import { List } from 'immutable';
import { createSelector, lruMemoize } from 'reselect';

import { isResourceLoading } from './common';

const getPlatformsData = (state) => state.getIn(['app', 'platforms']);
const isPlatformsLoading = lruMemoize(isResourceLoading);
const getPlatforms = lruMemoize(
    (data) => data.getIn(['platforms'], List()),
);

const isPlatformsLoadingRes = createSelector(getPlatformsData, isResourceLoading);
const getPlatformsItems = createSelector(getPlatformsData, (data) => getPlatforms(data).toJS());

export {
    isPlatformsLoading,
    getPlatformsData,
    getPlatforms,
    isPlatformsLoadingRes,
    getPlatformsItems,
};
